module.exports = __webpack_public_path__ + "static/img/106.7bfc131.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/201206/106.jpg
// module id = jb1m
// module chunks = 0